import { IsDefined, IsInt, IsObject, IsOptional, IsString, IsDate, IsDecimal } from 'class-validator';
import { BaseDto } from '../base.dto';
import type { PurchaseOrderInvoiceStatusDto } from './purchase-order-invoice-status.dto';
import type { PurchaseOrderItemDto } from '../purchaseOrderItem.dto';
import type { PurchaseOrderInvoiceDto } from './purchase-order-invoice.dto';

export class PurchaseOrderInvoiceItemDto extends BaseDto {
  @IsDefined()
  @IsInt()
  purchaseOrderInvoiceStatusId: number;

  @IsOptional()
  @IsInt()
  purchaseOrderInvoiceId?: number;

  @IsOptional()
  @IsInt()
  purchaseOrderItemId?: number;

  @IsOptional()
  @IsString()
  itemCode?: string;

  @IsOptional()
  @IsString()
  itemDescription?: string;

  @IsOptional()
  @IsString()
  measurementUnitDescription?: string;

  @IsOptional()
  @IsDecimal()
  quantity?: number;

  @IsOptional()
  @IsDecimal()
  price?: number;

  @IsOptional()
  @IsDecimal()
  value?: number;

  @IsOptional()
  @IsDecimal()
  vat?: number;

  @IsOptional()
  @IsDecimal()
  grossValue?: number;

  /* Relationships */

  @IsOptional()
  @IsObject()
  purchaseOrderInvoiceStatus?: PurchaseOrderInvoiceStatusDto;

  @IsOptional()
  @IsObject()
  purchaseOrderInvoice?: PurchaseOrderInvoiceDto;

  @IsOptional()
  @IsObject()
  purchaseOrderItem?: PurchaseOrderItemDto;
}
